import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { Card, Col, Container } from 'reactstrap';
import { BackButton } from '../../../components/Common/BackButton';
import Breadcrumb from '../../../components/Common/Breadcrumb';
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton';
import { SearchBar } from '../../../components/Common/SearchBar';
import Table1 from "../../../components/Common/TableContainer";
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal';
import { addNewLocation, deleteLocation, getLocations, updateLocation, updateLocationStatus } from '../../../store/actions';
import { LocationRegisterModal } from './LocationRegisterModal';

export const CatalogLayoutLocations = (props) => {

    // Redux
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getLocations("?limit=5000&page=0"));
    }, []);

    const { locations, loading, total, currentPage } = useSelector(state => ({
        locations: state.locations.locations,
        loading: state.locations.loading,
        total: state.locations.total,
        currentPage: state.locations.currentPage,
    }));

    // Modal HOOKS
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);

    const [searchData, setSearchData] = useState('');

    useEffect(() => {
        dispatch(getLocations(`?limit=20&page=0&search=${searchData}`));
    }, [searchData]);

    const onUpdate = (values) => {
        setIsUpdate(true);
        setRowInfo(values);
        setShowModal1(true);
    };

    const onDelete = (values) => {
        setRowInfo(values);
        setShowModal2(true);
    };

    const columns = React.useMemo(
        () => [
            {
                Header: 'Región',
                accessor: 'name',
                width: 400,
            },
            {
                Header: 'Estatus',
                width: '15%',
                Cell: ({ row }) => (
                    row.original.recordStatus
                        ? <div className='text-success'>Activo</div>
                        : <div className='text-danger'>Inactivo</div>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0 me-2" onClick={() => { onUpdate(row.original) }}>
                            <span className="mdi mdi-18px mdi-lead-pencil p-2"></span>
                        </button>
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0" onClick={() => { onDelete(row.original) }}>
                            <span className="mdi mdi-18px mdi-delete p-2"></span>
                        </button>
                    </div>
                ),
            },
        ],
        []
    );

    const RegisterModalRespInfo = (values, active) => {
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id };
            dispatch(updateLocation(updValue));
            dispatch(updateLocationStatus({ id: rowInfo.id, recordStatus: active }));
        } else {
            dispatch(addNewLocation(values));
        }
        setTimeout(() => {
            dispatch(getLocations("?limit=20&page=0"));
        }, 500);
        setIsUpdate(false);
        setRowInfo('');
    };

    const modalClose = () => {
        setIsUpdate(false);
    };

    const onDeleteConfirmation = () => {
        dispatch(deleteLocation(rowInfo));
        setRowInfo('');
    };

    const getPagination = (params) => {
        dispatch(getLocations(`${params}&search=${searchData}`));
    };

    return (
        <div className="page-content">
            <Container fluid>
                <Col className="col-12" style={{ padding: 20 }}>
                    <Card style={{ padding: 50 }}>

                        <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='LocationsCatalog' />

                        <Card style={{ padding: 20 }}>
                            <div className='pe-1'>
                                <BackButton props={props} />
                            </div>

                            <div className="row">
                                <div className="col-12 col-lg-9 mb-2 ps-3 pe-3">
                                    <SearchBar setSearchData={setSearchData} />
                                </div>
                                <div className="col-12 col-lg-3 pe-3">
                                    <NewRegisterButton setShowModal={setShowModal1} showModal={showModal1} />
                                </div>
                            </div>

                            <div className='ms-1'>
                                <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={locations} />
                            </div>

                            <LocationRegisterModal
                                setShowModal={setShowModal1}
                                showModal={showModal1}
                                modalRespInfo={RegisterModalRespInfo}
                                isUpdate={isUpdate}
                                rowInfo={rowInfo}
                                modalClose={modalClose}
                            />

                            <TableItemDeleteModal
                                onDeleteConfirmation={onDeleteConfirmation}
                                props={props}
                                setShowModal={setShowModal2}
                                showModal={showModal2}
                                modalHeader='Eliminar sede'
                                modalBodyLabel='¿Está seguro que desea eliminar la sede seleccionada?'
                            />

                        </Card>

                    </Card>
                </Col>
                <ToastContainer autoClose={2000} newestOnTop />
            </Container>
        </div>
    );
};

export default withRouter(CatalogLayoutLocations);